<template>
	<Row class="page-container-row always-show-scrollbar">
		<Col :span="24">
			<PageContainer :withPadding="false">
				<Row>
					<Col :span="24">
						<div class="dashboard-controls">
							<Select
								v-model:value="sessionStore.dashboardUpdatePeriodMinutes"
								:options="dashboardUpdatePeriodMinutesOptions"
								@change="sessionStore.updateDashboardUpdatePeriodMinutes"
								size="small"
							/>
						</div>
						<div class="dashboard-container">
							<SignalStats ref="signalStatsRef" />
							<BaseStationStatuses />
							<UserPulseStats ref="userPulseStatsRef" />
							<UserPulseLogs />
						</div>
					</Col>
				</Row>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { computed, ref, onMounted } from 'vue';
import { Row, Col, Select } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';

import { useSessionStore } from '@/stores/session';

import { useInterval } from '@/utils/useInterval';

import PageContainer from '@/components/common/PageContainer';

import SignalStats from '@/components/dashboard/SignalStats.vue';
import BaseStationStatuses from '@/components/dashboard/BaseStationStatuses.vue';
import UserPulseStats from '@/components/dashboard/UserPulseStats.vue';
import UserPulseLogs from '@/components/dashboard/UserPulseLogs.vue';

const MINUTES = [1, 5, 30];

export default {
	components: {
		Row, Col, Select,
		PageContainer,
		SignalStats,
		BaseStationStatuses,
		UserPulseStats,
		UserPulseLogs,
	},
	setup() {
		const { t } = useI18n();
		const sessionStore = useSessionStore();
		const userPulseStatsRef = ref(null);
		const signalStatsRef = ref(null);
		const dashboardUpdatePeriodMinutesOptions = computed(() => {
			return MINUTES.map(minutes => ({ label: t('dashboard.controls.updatePeriodMinutesLabel', minutes), value: minutes }));
		});
		const minutes = ref(0);
		const updateDashboard = () => {
			userPulseStatsRef.value.refresh();
			signalStatsRef.value.refresh();
		}
		useInterval(() => {
			minutes.value++;
			if (minutes.value >= sessionStore.dashboardUpdatePeriodMinutes) {
				minutes.value = 0;
				updateDashboard();
			}
		}, 60000, false);
		onMounted(() => {
			updateDashboard();
		});
		return {
			sessionStore,
			dashboardUpdatePeriodMinutesOptions,
			userPulseStatsRef,
			signalStatsRef,
		};
	},
}
</script>

<style scoped>
.dashboard-controls {
	display: flex;
	justify-content: flex-end;
	border-bottom: 1px solid #d9d9d9;
	padding: 16px 24px;
	background-color: #f3f3f3;
}
.dashboard-container{
	display: grid;
	padding: 16px;
	gap: 16px;
	grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
}
</style>